import { useLoginStore, useAppGlobalStore } from '@/store/app'
import { getToken } from './authentication'
import { authentication } from '@/plugins/firebase'
import router from '@/router'
const apiUrl = import.meta.env.VITE_BASE_API_URL

async function request(url: string, options: any = {}) {
  const loginStore = useLoginStore()
  try {
    options.headers = Object.assign(options.headers || {}, {
      Authorization: `Bearer ${loginStore.token}`
    })
    const response = await fetch(`${apiUrl}${url}`, options)
    return handleResponse(response)
  } catch (error: any) {
    // If the error is due to an expired token, refresh the token and retry the request
    if (error.message.includes('401')) {
      try {
        const firebaseUser = authentication.currentUser
        let token = ''
        if (firebaseUser) {
          token = await getToken(true)
        } else if (loginStore.refreshToken) {
          token = await refreshToken()
        } else {
          throw new Error('FirebaseUser & refreshToken not exists')
        }
        loginStore.setToken(token)
        options.headers.Authorization = `Bearer ${token}`
        const retryResponse = await fetch(`${apiUrl}${url}`, options)
        return handleResponse(retryResponse)
      } catch (error: any) {
        router.push({ name: 'Login', replace: true })
        const appGlobalStore = useAppGlobalStore()
        appGlobalStore.setSnackbarText('La sesión ha expirado')
      }
    } else {
      // For other errors, simply propagate the error
      throw error
    }
  }
}

function handleResponse(response: any) {
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }
  return response
}

async function refreshToken() {
  const loginStore = useLoginStore()
  const appGlobalStore = useAppGlobalStore()
  try {
    const response = await fetch(`${apiUrl}/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Application-Version': '2.23.0'
      },
      body: JSON.stringify({ refreshToken: loginStore.refreshToken })
    })
    const responseAux = handleResponse(response)
    const result = await responseAux.json()
    const token = result.token
    const refreshToken = result.refreshToken
    loginStore.setRefreshToken(refreshToken)
    return token
  } catch (error: any) {
    router.push({ name: 'Login', replace: true })
    appGlobalStore.setSnackbarText('La sesión ha expirado')
  }
}

export default request
